import axios from "axios";
import { PropsWithChildren } from "react";
import { useAuth } from "react-oidc-context";



export default (props: PropsWithChildren<{}>) => {

    const auth = useAuth();
    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Oops... {auth.error.message}</div>;
    }
    
    if(!auth.isAuthenticated){
        auth.signinRedirect()
        return <>login</>
    }else{
        // 设置默认的 Authorization 头
        axios.defaults.headers.common["Authorization"] = `Bearer ${auth.user?.access_token}`;
        return <>{props.children}</>
    }


    

}